import styled from "styled-components";
import Block from "./Block";
import {Loader} from "./loader/Loader";
import React from "react";

export const StyledBlockChart = styled(Block)`
  height: 400px;
  .block-content {
    height: 100%;

    .block-body {
      height: 320px;
    }

    .container-fluid {
      height: 100%;
    }
  };
`
export default function BlockChart({title, isLoading, isSuccess, retry, children}) {
  return <StyledBlockChart title={title}>
    <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess} retry={retry} minHeight={"100%"}>
      {children}
    </Loader>
  </StyledBlockChart>
}
